import { Pipe, PipeTransform } from '@angular/core';
import { DisplayLabel } from '../models/displayLabel';

@Pipe({
  name: 'displayLabelSort',
})
export class DisplayLabelSortPipe implements PipeTransform {
  transform(items: DisplayLabel[] = []): DisplayLabel[] {
    return items.sort((a: DisplayLabel, b: DisplayLabel) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
  }
}
